const ANTECH_STATUS = {
    INC_PRE_ORDER: "Incomplete Pre Order",
    SUBMITTED: "Submitted",
    IN_PROGRESS: "In Progress",
    PRE_ORDER: "Pre Order",
    PARTIAL: "Partial",
    UPDATED: "Updated/Corrected",
    FINAL: "Final",
    DRAFT: "Draft"
};

const ANTECH_VALIDITY_PERIOD = 30;
const ANTECH_FETCH_RESULT_PERIOD_IN_MONTH = 6;

export default {
    ANTECH_STATUS,
    ANTECH_VALIDITY_PERIOD,
    ANTECH_FETCH_RESULT_PERIOD_IN_MONTH
};